import { render, staticRenderFns } from "./TheBankrupt.vue?vue&type=template&id=d41930c0&"
import script from "./TheBankrupt.vue?vue&type=script&lang=js&"
export * from "./TheBankrupt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports